import type UserPreferencesDataService from './user-preferences.data-service';
import type ModalConversationService from '../../../modals/modal-conversation.service';
import type {BasicUser, UserPreference} from 'typings/portaro.be.types';
import {states} from 'shared/constants/portaro.constants';
import {clone} from 'lodash-es';
import {isNullOrUndefined} from 'shared/utils/custom-utils';
import {isInterruptedActionResponse} from '../../../modals/modal-utils';
import type FinishedResponseInteractionService from 'shared/services/finished-response-interaction.service';


export class UserPreferencesService {
    public static serviceName = 'userPreferencesService';

    /*@ngInject*/
    constructor(private userPreferencesDataService: UserPreferencesDataService,
                private modalConversationService: ModalConversationService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    public async setUserPreferences(user: BasicUser, preferenceKeys = [] as number[], message = '') {
        const userPreferences = await this.query(user.id, preferenceKeys);
        try {
            await this.modalConversationService.userPreferencesModal({
                user,
                userPreferences,
                message
            });
        } catch (exceptionResponse) {
            if (!isInterruptedActionResponse(exceptionResponse)) {
                this.finishedResponseInteractionService.showFailedResponseInToast(exceptionResponse);
            }
        }

    }

    public async query(userId: number, preferenceKeys = [] as number[]): Promise<UserPreference[]> {
        const userPreferences = await this.userPreferencesDataService.query(userId, preferenceKeys);
        for (const userPreference of userPreferences) {
            this.initUserPreference(userPreference);
        }
        return userPreferences;
    }

    public async save(preference: UserPreference): Promise<UserPreference> {
        preference.state = states.PROCESSING;
        const savedPreference = await this.userPreferencesDataService.save(preference);
        this.initUserPreference(savedPreference);
        return savedPreference;
    }

    public async setToDefault(preference: UserPreference): Promise<UserPreference> {
        preference.editedValue = null;
        return this.save(preference);
    }

    private initUserPreference(preference: UserPreference) {
        preference.state = states.NORMAL;
        preference.editedValue = !isNullOrUndefined(preference.effectiveValue) ? clone(preference.effectiveValue) : null;
    }
}